import { escapeHtml } from './printUtils';
// src/utils/dashboardUtils.js

// 🚀 정확한 한국 로컬 날짜를 가져오는 함수
export const getLocalDateString = (dateObj = new Date()) => {
  const year = dateObj.getFullYear();
  const month = String(dateObj.getMonth() + 1).padStart(2, '0');
  const day = String(dateObj.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

// 🚀 특정 날짜가 포함된 주의 월요일~일요일 범위를 구하는 함수
export const getWeekRange = (dateStr) => {
  const [y, m, d] = dateStr.split('-');
  const date = new Date(y, m - 1, d);
  const day = date.getDay();
  const diffToMonday = date.getDate() - day + (day === 0 ? -6 : 1);
  const monday = new Date(y, m - 1, diffToMonday);
  const sunday = new Date(y, m - 1, diffToMonday + 6);
  return {
    start: getLocalDateString(monday),
    end: getLocalDateString(sunday),
    label: `${getLocalDateString(monday)} ~ ${getLocalDateString(sunday)}`
  };
};

// 🚀 일일 매출 내역 다운로드 (HTML 템플릿)
export const downloadDailyReport = (dailyAsList, dailySalesTotal) => {
  const title = "오늘의 매출 상세 내역서 (VAT 제외)";
  const tableData = dailyAsList.map(r => [
    r.settleDate || r.asDate, 
    `${r.customerName} (${r.carNumber})`, 
    r.mechanic, 
    `₩ ${Number(r.costExVat || Math.round(((Number(r.totalCost)||0) + (Number(r.discount)||0))/1.1)).toLocaleString()}`
  ]);

  const printWindow = window.open('', '_blank');
  const html = `
    <html>
      <head>
        <title>${escapeHtml(title)}</title>
        <style>
          @page { size: A4; margin: 10mm; }
          body { font-family: sans-serif; padding: 20px; color: #1e293b; }
          h1 { font-size: 18pt; border-bottom: 2px solid #334155; padding-bottom: 10px; text-align: center; }
          table { width: 100%; border-collapse: collapse; table-layout: fixed; margin-top: 20px; }
          th { background: #f1f5f9; padding: 10px; border: 1px solid #cbd5e1; font-size: 9pt; }
          td { padding: 8px; border: 1px solid #e2e8f0; font-size: 8.5pt; text-align: center; word-wrap: break-word; }
          .text-left { text-align: left; }
          .text-right { text-align: right; }
          .total-section { margin-top: 20px; padding: 15px; border: 1px solid #cbd5e1; text-align: right; background: #f8fafc; font-weight: bold; }
        </style>
      </head>
      <body>
        <div style="font-size: 8pt; text-align: right;">출력 일시: ${new Date().toLocaleString()}</div>
        <h1>${escapeHtml(title)}</h1>
        <table>
          <thead>
            <tr>
              <th style="width: 30px;">No</th>
              <th style="width: 80px;">날짜</th>
              <th style="width: 220px;">고객명 (차량번호)</th>
              <th style="width: 80px;">정비사</th>
              <th style="width: 100px;">매출금액(공급가)</th>
            </tr>
          </thead>
          <tbody>
            ${tableData.map((row, idx) => `
              <tr>
                <td>${idx + 1}</td>
                <td>${escapeHtml(row[0])}</td>
                <td class="text-left">${escapeHtml(row[1])}</td>
                <td>${escapeHtml(row[2])}</td>
                <td class="text-right"><b>${row[3]}</b></td>
              </tr>
            `).join('')}
          </tbody>
        </table>
        <div class="total-section">오늘 매출 합계(VAT 제외): ₩ ${dailySalesTotal.toLocaleString()}</div>
        <script>setTimeout(() => { window.print(); window.close(); }, 500);</script>
      </body>
    </html>
  `;
  printWindow.document.write(html);
  printWindow.document.close();
};

// 🚀 커스텀 리포트 다운로드 (HTML 템플릿)
export const printAdvancedReport = (title, tableHeaders, tableData, totalAmount) => {
  const totalValueStr = typeof totalAmount === 'string' ? totalAmount : `₩ ${Number(totalAmount).toLocaleString()}`;
  const printWindow = window.open('', '_blank');
  const html = `
    <html>
      <head>
        <title>${escapeHtml(title)}</title>
        <style>
          @page { size: A4; margin: 8mm; }
          body { font-family: 'Malgun Gothic', sans-serif; padding: 0; color: #1e293b; line-height: 1.3; }
          h1 { font-size: 16pt; color: #1e293b; border-bottom: 2px solid #334155; padding-bottom: 8px; margin-bottom: 15px; text-align: center; }
          table { width: 100%; border-collapse: collapse; table-layout: fixed; }
          th { background: #f1f5f9; padding: 7px 2px; text-align: center; border: 1px solid #cbd5e1; color: #475569; font-size: 8pt; }
          td { padding: 5px 2px; border: 1px solid #e2e8f0; font-size: 7.5pt; text-align: center; word-wrap: break-word; }
          .code-name { text-align: left; padding-left: 4px; line-height: 1.2; }
          .part-no { font-weight: bold; color: #64748b; font-size: 7pt; display: block; }
          .part-name { font-size: 8pt; color: #1e293b; }
          .text-left { text-align: left; padding-left: 8px; }
          .text-right { text-align: right; padding-right: 6px; }
          .price-bold { font-size: 9.5pt; font-weight: 900; color: #1e293b; }
          .qty-narrow { font-size: 8pt; color: #dc2626; font-weight: bold; }
          .total-section { margin-top: 15px; padding: 10px; border: 1px solid #cbd5e1; text-align: right; background: #f8fafc; }
          .total-label { font-size: 9pt; font-weight: bold; }
          .total-value { font-size: 11pt; font-weight: bold; color: #2563eb; margin-left: 8px; }
          .date-info { font-size: 7pt; color: #94a3b8; text-align: right; margin-bottom: 5px; }
          .highlight-red { color: #dc2626; font-weight: bold; }
        </style>
      </head>
      <body>
        <div class="date-info">출력 일시: ${new Date().toLocaleString()} | E2B CRM 시스템</div>
        <h1>${escapeHtml(title)}</h1>
        <table>
          <thead>
            <tr>
              <th style="width: 20px;">No</th>
              ${tableHeaders.map((h, i) => {
                let width = "auto";
                if(h === "날짜") width = "65px";
                if(h.includes("고객") || h === "관련 차량(고객)") width = "150px";
                if(h === "부품명 (작업명)") width = "160px";
                if(h === "담당 정비사") width = "60px";
                if(h.includes("금액")) width = "95px";
                if(h === "모델") width = "55px";
                if(h.includes("정보")) width = "185px";
                if(h.includes("가치") || h.includes("단가") || h.includes("원가")) width = "80px";
                if(h === "기초" || h === "사용" || h.includes("현재") || h.includes("수량")) width = "50px";
                return `<th style="width: ${width};">${escapeHtml(h)}</th>`;
              }).join('')}
            </tr>
          </thead>
          <tbody>
            ${tableData.map((row, idx) => `
              <tr>
                <td>${idx + 1}</td>
                ${row.map((cell, cIdx) => {
                  let className = "";
                  let content = escapeHtml(cell);
                  if(tableHeaders[cIdx].includes("고객") || tableHeaders[cIdx] === "부품명 (작업명)") {
                      className = "text-left";
                      content = `<b style="font-size: 8.5pt;">${escapeHtml(cell)}</b>`;
                  }
                  if((title.includes('부품') || title.includes('재고')) && tableHeaders[cIdx].includes("정보")) {
                    const lines = String(cell).split('\\n');
                    content = `<div class="code-name"><span class="part-no">${lines[0] || ''}</span><span class="part-name">${lines[1] || ''}</span></div>`;
                  } else {
                    if(String(cell).includes('₩')) className = "text-right price-bold";
                    if(String(cell).includes('EA') || String(cell).includes('-') || String(cell).includes('품절')) className = "text-right qty-narrow";
                  }
                  return `<td class="${className}">${content}</td>`;
                }).join('')}
              </tr>
            `).join('')}
          </tbody>
        </table>
        <div class="total-section">
          <span class="total-label">합계:</span>
          <span class="total-value">${totalValueStr}</span>
        </div>
        <script>setTimeout(() => { window.print(); window.close(); }, 500);</script>
      </body>
    </html>
  `;
  printWindow.document.write(html);
  printWindow.document.close();
};